import type { ParametrosClienteFielModel } from "../models/parametrosClienteFielModel"

export enum ParametrosClienteFielActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type ParametrosClienteFielActionModel =
    | { type: ParametrosClienteFielActionsTypes.CARREGAR; payload: ParametrosClienteFielModel }
    | {
          type: ParametrosClienteFielActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof ParametrosClienteFielModel; valor: string | number | boolean | null }
      }
    | { type: ParametrosClienteFielActionsTypes.RESETAR }
